
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import twitchService from '@/services/twitch.service';

  @Component({
    computed: {
      ...mapGetters([
        'redirectUrl'
      ])
    }
  })
  export default class TwitchLink extends Vue {
    created() {
      twitchService.goToTwitch(this, this.$store.getters.redirectUrl);
    }
  }
